/**
 * Serviço de Usuários (Admin)
 *
 * Gerencia operações de administração de usuários via Auth Service.
 * Endpoints: /admin/users
 */

import { apiServiceClient } from "../config/api";

/**
 * Serviço de usuários (admin)
 */
export const usersService = {
  /**
   * Cria um novo usuário
   * @param {Object} userData - { email, password, nome, role, ativo }
   * @returns {Promise<Object>}
   */
  async create(userData) {
    return apiServiceClient.post("/admin/users", userData);
  },

  /**
   * Lista usuários com filtros
   * @param {Object} params - { search, role, ativo, nucleo_id }
   * @returns {Promise<Array>}
   */
  async list(params = {}) {
    const queryParams = {};
    if (params.role) queryParams.role = params.role;
    if (params.ativo !== undefined && params.ativo !== null) {
      queryParams.ativo = params.ativo ? "true" : "false";
    }
    if (params.search) {
      queryParams.search = params.search.trim();
    }
    if (params.nucleo_id) {
      queryParams.nucleo_id = params.nucleo_id;
    }

    return apiServiceClient.get("/admin/users", queryParams);
  },

  /**
   * Busca usuário por ID
   * @param {string|number} id
   * @returns {Promise<Object>}
   */
  async getById(id) {
    return apiServiceClient.get(`/admin/users/${id}`);
  },

  /**
   * Atualiza usuário
   * @param {string|number} id
   * @param {Object} userData
   * @returns {Promise<Object>}
   */
  async update(id, userData) {
    return apiServiceClient.patch(`/admin/users/${id}`, userData);
  },

  /**
   * Remove/desativa usuário
   * @param {string|number} id
   * @returns {Promise<null>}
   */
  async delete(id) {
    return apiServiceClient.delete(`/admin/users/${id}`);
  },

  /**
   * Vincula usuário a um núcleo
   * @param {string|number} userId
   * @param {Object} nucleoData - { nucleo_id, ativo, data_inicio, etc }
   * @returns {Promise<Object>}
   */
  async vincularNucleo(userId, nucleoData) {
    return apiServiceClient.post(`/admin/users/${userId}/nucleos`, nucleoData);
  },

  /**
   * Desvincula usuário de um núcleo
   * @param {string|number} userId
   * @param {string|number} relacionamentoId - ID do relacionamento
   * @returns {Promise<null>}
   */
  async desvincularNucleo(userId, relacionamentoId) {
    return apiServiceClient.delete(`/admin/users/${userId}/nucleos/${relacionamentoId}`);
  },

  /**
   * Lista núcleos de um usuário
   * @param {string|number} userId
   * @param {Object} params - { ativo: boolean }
   * @returns {Promise<Array>}
   */
  async getNucleos(userId, params = {}) {
    const queryParams = {};
    if (params.ativo !== null && params.ativo !== undefined) {
      queryParams.ativo = params.ativo ? "true" : "false";
    }
    return apiServiceClient.get(`/admin/users/${userId}/nucleos`, queryParams);
  },
};

export default usersService;

